import { RequestContext } from "@multiweb/types/multiweb";
import { IItemRights, ItemRights, RightType } from "Global/Base/Rights/RightTypes";
import { IEvaluatedConditionResult } from "OW.Remoting/Remoting/Rights";
import { BaseRightsEvaluator } from "./BaseRightsEvaluator";

/** Vyhodnocuje práva pro hromadnou editaci */
export class MultiObjectRightsEvaluator extends BaseRightsEvaluator {
    /**
     * V případě hromadné editace se podmínky nevyhodnocují. Místo toho se vrací výchozí hodnota podle typu práva
     * @param rightType
     */
    private _getDefaultRightValueForCond(rightType: RightType): boolean {
        switch (rightType) {
            case RightType.edit:
            case RightType.visible:
            case RightType.enabled:
                return false;
            case RightType.required:
            case RightType.postponedRequired:
            case RightType.recommended:
                return true;
            default:
                this._logger.warn(`Missing condition default right value for rightType "${RightType[rightType]}"!`); // `
                return false;
        }
    }

    /**
     * Z dat práva a vyhodnocených podmínek vypočítá výslednou hodnotu práva v multieditaci
     * MultiEditace nepotřebuje vyhodnocovat práva zadaná podmínkou, jen vrací výchozí hodnotu podle typu práva.
     * @param itemRight Data práva
     * @param _evaluatedConditions Vyhodnocené podmínky
     * @param rightType
     */
    protected override _getRightValue(itemRight: IItemRights, _evaluatedConditions: IEvaluatedConditionResult[], rightType: RightType): IItemRights {
        if (!itemRight.conditionID) {
            return itemRight; // pokud není podmínka, tak bere hodnota tvrdého práva
        } else {
            const rightValue = this._getDefaultRightValueForCond(rightType);
            return new ItemRights(itemRight.roleID, itemRight.level, rightValue, itemRight.conditionID, itemRight.isNegative);
        }
    }

    public override async evaluateCondition(conditionID: string, _isStatic: boolean, rightType: RightType, _requestContext?: RequestContext): Promise<IEvaluatedConditionResult> {
        return Promise.resolve({ ID: conditionID, Result: this._getDefaultRightValueForCond(rightType) });
    }

    protected override _isNegative(right: IItemRights): boolean {
        return right.isNegative && !right.conditionID;
    }
}
